import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData, postData } from "../../../apiservice/apis";

// ── Thunks ──────────────────────────────────────────────────────────────────
export const fetchVatFilingStatus = createAsyncThunk(
  "vatFiling/fetchStatus",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchData("/reports/vat-filing-status");
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markQuarterFiled = createAsyncThunk(
  "vatFiling/markFiled",
  async ({ id, reference_no, notes }, { rejectWithValue }) => {
    try {
      const res = await postData("/reports/vat-mark-filed", { id, reference_no, notes });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// ── Slice ────────────────────────────────────────────────────────────────────
const vatFilingSlice = createSlice({
  name: "vatFiling",
  initialState: {
    quarters:     [],
    staggerMonth: 1,
    loading:      false,
    saving:       false,
    error:        null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchVatFilingStatus.pending, (state) => {
        state.loading = true;
        state.error   = null;
      })
      .addCase(fetchVatFilingStatus.fulfilled, (state, action) => {
        state.loading      = false;
        state.quarters     = action.payload.data     || [];
        state.staggerMonth = action.payload.staggerMonth || 1;
      })
      .addCase(fetchVatFilingStatus.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      })
      // mark filed
      .addCase(markQuarterFiled.pending, (state) => {
        state.saving = true;
      })
      .addCase(markQuarterFiled.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(markQuarterFiled.rejected, (state) => {
        state.saving = false;
      });
  },
});

export default vatFilingSlice.reducer;